import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Background videos now render through snippets/poster-video.liquid, and assets/media-lifecycle.js decides
    // when (and whether, by tier) to attach the source. Only legacy markup with its own refs is handled here.
    if (this.querySelector('[data-poster-video]')) return;

    const { videoSources, videoElement } = this.refs;
    if (!videoSources || !videoElement) return;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
